module.exports = __webpack_public_path__ + "img/preview-fronx-boostergreen.a063929e.jpg";